export const typingIndicatorOptions = {
	id: '',
	agentName: '',
};
